import React, { useEffect } from "react";
import "./Home.css";


const Header = () => {

  return (
    <>
       <section id="home" className="hero">
        <div className="hero-content">
          <h1>
            Expert guidance <br/>for the  <span className="highlight">care sector</span>
          </h1>

          <p>
           Total Care Advisory provides specialist consultancy services for care providers, healthcare
            organisations, and social care businesses across the UK. We are dedicated to enhancing 
            compliance, operational efficiency, financial performance, and overall quality of care.
          </p>
        </div>
      </section>
      </>
  );
};

export default Header;


























